<!--
	作者：masonchen
	时间：2017-04-10
	描述：轨迹回放页面
-->
<template>
	<!--车辆监控页面_右侧tab面板之车辆预警开始-->
	<div class="tab-bar">
		<div class="tab-row vehicle_detail">
				<ul>
					<li><span>车辆ID：</span><em>{{carInfo.vehicleId}}</em></li>
					<li><span>服务卡号：</span><em>{{carInfo.vehicleAccount}}</em></li>
					<li><span>服务起始日：</span><em>{{startTime}}</em></li>
					<li><span>服务结束日：</span><em>{{endTime}}</em></li>
					<li><span>车型车系：</span><em>{{carInfo.modelName}}</em></li>
					<li><span>车牌号：</span><em>{{carInfo.plateNumber}}</em></li>
					<li><span>车辆登记日期：</span><em>{{saleTime}}</em></li>
					<li><span>车主：</span><em>{{carInfo.vehicleOwnerName}}</em></li>
					<li><span>联系方式：</span><em>{{carInfo.phone}}</em></li>
				<!--	<li><span>设备保单号：</span><em>{{carInfo.insuranceNo}}</em></li>-->
				</ul>
		</div>
		<div v-if="permission.indexOf('monitorVehicle_alarmPanelCarDetail') == -1" class="track_bottom_btn" @click="addTab"><i><a class="ico_02">更多详情</a></i></div>
	</div>
	<!--车辆监控页面_右侧tab面板之车辆预警结束-->
</template>
<script>
	import {
		mapState
	} from 'vuex'
	import {goTabMixin} from 'util/util'
	export default {
		name: 'VehicleDetail',
		mixins:[goTabMixin],
		data() {
			return {
				permission:this.$store.state.permission.permission["monitorVehicle"]?this.$store.state.permission.permission["monitorVehicle"]:[],
				carInfo:{},
				startTime:'',
				endTime:'',
				saleTime:''
			}
		},
		computed: {
			...mapState({
				vDetail:state=>state.monitor.vDetail
			})
		},
		watch:{
			vDetail(val){
				this.carInfo = val;
			},
			'vDetail.vehicleId'(val){
				this.carInfo = this.vDetail
				this.startTime = ''
				if(this.carInfo.serviceStartTime){this.startTime = this.carInfo.serviceStartTime.split(' ')[0]}
				this.endTime = ''
				if(this.carInfo.serviceEndTime){this.endTime = this.carInfo.serviceEndTime.split(' ')[0]}
				this.saleTime = ''
				if(this.carInfo.startSaleTime){this.saleTime = this.carInfo.startSaleTime.split(' ')[0]}
			}
		},
		methods: {
			addTab(){//进入tab窗口
				this.openDidiCarFile(this.carInfo.plateNumber, this.carInfo.vehicleId)
			}
		}

	}
</script>

<style>

</style>


// WEBPACK FOOTER //
// VehicleDetail.vue?47e37c59